import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Hero from "./components/Hero";
import HowItWorks from "./components/HowItWorks";
import Services from "./components/Services";
import WhyChooseUs from "./components/WhyChooseUs";
import ContactSection from "./components/ContactSection";
import FAQ from "./components/FAQ";
import Footer from "./components/Footer";
import TermsAndConditions from "./pages/TermsAndConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import AboutUs from "./pages/AboutUs";
import { Toaster } from "./components/ui/toaster";
import { mockData } from "./mockData";

const Home = () => {
  const handleEmailClick = () => {
    window.location.href = 'mailto:business@evoxmedia.co?subject=Inquiry about Evox Media Services';
  };

  return (
    <div className="min-h-screen">
      <Hero onCtaClick={handleEmailClick} />
      <HowItWorks onCtaClick={handleEmailClick} />
      <Services />
      <WhyChooseUs />
      <ContactSection onCtaClick={handleEmailClick} />
      <FAQ />
      <Footer />
      <Toaster />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/terms" element={<TermsAndConditions />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
